export default "\n<div @fadeSlideInOut class=\"card\">\n    <loyaltic-pof-live></loyaltic-pof-live>\n</div>\n"